{
  "cycle.entite.pieces_preuve": "Test evidence files",
  "journalAudit.action.test.evidence_uploaded": "Evidence file uploaded",
  "journalAudit.action.test_plan.published": "Test plan version published"
}
